import { render, staticRenderFns } from "./wxroutingprice.vue?vue&type=template&id=297e584a&scoped=true&"
import script from "./wxroutingprice.vue?vue&type=script&lang=js&"
export * from "./wxroutingprice.vue?vue&type=script&lang=js&"
import style0 from "./wxroutingprice.vue?vue&type=style&index=0&id=297e584a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e584a",
  null
  
)

export default component.exports